import {
  AppBar, Avatar, Button, Drawer, Grid, Hidden, IconButton, List,
  ListItem, ListItemIcon, ListItemText, makeStyles, Toolbar,
  Typography, useTheme
} from '@material-ui/core';
import AccountCircle from '@material-ui/icons/AccountCircle';
import AssignmentIcon from '@material-ui/icons/Assignment';
import ChromeReaderModeIcon from '@material-ui/icons/ChromeReaderMode';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import HomeIcon from '@material-ui/icons/Home';
import InfoIcon from '@material-ui/icons/Info';
import FileIcon from '@material-ui/icons/InsertDriveFile';
import LastPage from '@material-ui/icons/LastPage';
import MenuIcon from '@material-ui/icons/Menu';
import RateReview from '@material-ui/icons/RateReview';
import SettingsIcon from '@material-ui/icons/Settings';
import SpeakerNotesIcon from '@material-ui/icons/SpeakerNotes';
import WorkIcon from '@material-ui/icons/Work';
import clsx from 'clsx';
import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import { NavLink, withRouter } from 'react-router-dom';
import { useAuth } from '../../../context/auth';
import getRoutes from '../../Routes/RoutesMap';
import accountIcon from '/public/images/account_icon.png';
import brasilFlag from '/public/images/brasil_flag.png';
import euaFlag from '/public/images/eua_flag.png';
import logo from '/public/images/logo_aa.png';
import spanishFlag from '/public/images/spanish_flag.png';

const { APP_VERSION } = process.env;

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    width: "100%",
    height: "100%",
    flex: 1,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: theme.palette.primary.contrastText
  },
  title: {
    ...theme.typography.h4,
  },
  drawer: {
    width: "15vw",
    flexShrink: 0
  },
  drawerPaper: {
    [theme.breakpoints.up('sm')]: {
      width: "15vw",
    },
    [theme.breakpoints.down('md')]: {
      width: "30vw",
    },
    boxShadow: '2px 0px 0px 0px rgba(0, 0, 0, 0.05)',
  },
  drawerContainer: {
    overflow: 'auto',
    marginTop: "2vh",
    paddingLeft: '16px',
    paddingRight: '16px',
    height: "100%"
  },
  countryFlags: {
    display: 'flex',
    align: 'horizontal',
    marginRight: theme.spacing(6)
  },
  countryFlag: {
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5)
  },
  user: {
    display: 'flex',
    align: 'horizontal',
    marginRight: theme.spacing(6),
    textAlign: 'center',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    maxWidth: 'calc(100% - 15vw)',
  },
  border: {
    borderRight: "none"
  },
  itemMenu: {
    backgroundColor: '#f9f9f9',
    color: '#535353',
    border: '1px solid #d1d1d1',
    borderRadius: 5,
    marginBottom: 10,
    minHeight: "5vh",
    width: '100%',
    padding: '8px',

    [theme.breakpoints.down('lg')]: {
      minHeight: '6vh',
    },

    transition: 'all 0.3s ease',

    "&:hover": {
      backgroundColor: '#e3e2e2',
    },
  },
  itemMenuDisabled: {
    backgroundColor: '#cfcfcf',
    color: '#535353',
    border: '1px solid #d1d1d1',
    borderRadius: 5,
    marginBottom: 10,
    minHeight: "5vh",
    width: '100%',
    padding: '8px',

    [theme.breakpoints.down('lg')]: {
      minHeight: '6vh',
    },
  },
  itemTitle: {
    fontSize: '14px',
    fontWeight: 'bold'
  },
  selected: {
    backgroundColor: theme.palette.primary.dark,
    color: '#fff',
    
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  itemSelected: {
    color: '#fff',
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
  },
  iconSpace: {
    minWidth: 35
  },
  systemTitle: {
    gap: '16px',
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
  }
}));

const environmentLabel = process.env.ENVIRONMENT_LABEL_DISPLAYED_ON_SCREEN;

const NavigationBar = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const { t, i18n, provider } = props;
  const { account, logout } = provider;
  const [mobileOpen, setMobileOpen] = useState(false);
  const { userAccess } = useAuth();

  const [environmentInfo, setEnvironmentInfo] = useState({});

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const activeRoute = (routeName) => {
    if (routeName === 'home') {
      return props.location.pathname === "/";
    } else {
      return props.location.pathname.includes(routeName);
    }
  }

  const renderSwitch = (param, selected) => {
    switch (param) {
      case 'home':
        return <HomeIcon style={{...(selected ? {color: '#fff' } : {color: '#535353'}), fontSize: "18px"}} />;
      case 'committee':
        return <GroupAddIcon style={{...(selected ? {color: '#fff' } : {color: '#535353'}), fontSize: "18px"}} />;
      case 'theme':
        return <SpeakerNotesIcon style={{...(selected ? {color: '#fff' } : {color: '#535353'}), fontSize: "18px"}} />;
      case 'role':
        return <InfoIcon style={{...(selected ? {color: '#fff' } : {color: '#535353'}), fontSize: "18px"}} />;
      case 'slot':
        return <ChromeReaderModeIcon style={{...(selected ? {color: '#fff' } : {color: '#535353'}), fontSize: "18px"}} />;
      case 'meeting':
        return <WorkIcon style={{...(selected ? {color: '#fff' } : {color: '#535353'}), fontSize: "18px"}} />;
      case 'minutes':
        return <RateReview style={{...(selected ? {color: '#fff' } : {color: '#535353'}), fontSize: "18px"}} />;
      case 'actions':
        return <AssignmentIcon style={{...(selected ? {color: '#fff' } : {color: '#535353'}), fontSize: "18px"}} />;
      case 'finalDeliberations':
        return <LastPage style={{...(selected ? {color: '#fff' } : {color: '#535353'}), fontSize: "18px"}} />;
      case 'fileManagement':
        return <FileIcon style={{...(selected ? {color: '#fff' } : {color: '#535353'}), fontSize: "18px"}} />;
      case 'managementProfiles':
        return <AccountCircle style={{...(selected ? {color: '#fff' } : {color: '#535353'}), fontSize: "18px"}} />;
      case 'systemManagementBusinessUnits':
        return <SettingsIcon style={{...(selected ? {color: '#fff' } : {color: '#535353'}), fontSize: "18px"}} />;
    }
  };

  const drawer = (
    <>
      <Grid container className={classes.drawerContainer}>
        <Grid container item >
          <List style={{width: '100%'}}>
            {getRoutes().filter(w => w.showMenu).map((prop, key) => {
              let isDisabled = true;

              const menuFeatures = typeof prop.funcinality === 'string' ? [prop.funcinality] : prop.funcinality;

              const userHasFeatureAccess = menuFeatures?.some(func => userAccess?.hasOwnProperty(func));

              if (userAccess && userHasFeatureAccess) {
                isDisabled = menuFeatures.some(func => userAccess[func] === false);
              } else if (prop.resourceName === 'home') {
                isDisabled = false;
              }

              return isDisabled ? (
                <ListItem
                  disabled={true}
                  key={key}
                  // component={() => ( <div style={{cursor: 'block'}}/> )}
                  className={clsx(classes.itemMenuDisabled)}
                >
                  <ListItemIcon className={classes.itemTitle} classes={{ root: classes.iconSpace }}>
                    {renderSwitch(prop.resourceName, false)}
                  </ListItemIcon>
                  <ListItemText classes={{ primary: classes.itemTitle }} primary={t(`menu.${prop.resourceName}.link.parent`)} />
                </ListItem>
              ) : (
                <ListItem
                  disabled={false}
                  component={NavLink}
                  key={key}
                  to={prop.path}
                  className={clsx(classes.itemMenu, activeRoute(prop.resourceName) && classes.selected)}
                >
                  <ListItemIcon className={classes.itemTitle} classes={{ root: classes.iconSpace }}>
                    {renderSwitch(prop.resourceName, activeRoute(prop.resourceName))}
                  </ListItemIcon>
                  <ListItemText classes={{ primary: classes.itemTitle }} primary={t(`menu.${prop.resourceName}.link.parent`)} />
                </ListItem>
              )
            })}
          </List>
        </Grid>
        <Grid container item alignItems="flex-end">
          <Typography variant="caption">
            {t('appversion')} : {APP_VERSION}
          </Typography>
        </Grid>
      </Grid>
    </>
  );

  return (
    <div className={classes.root}>
      <AppBar position="fixed" elevation={0} className={classes.appBar}>
        <Toolbar>
          <IconButton
            color="primary"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <MenuIcon />
          </IconButton>

          <img src={logo} alt="Anglo American" width="300" style={{ paddingRight: "8vw" }} />
          
          <div className={classes.systemTitle}>
            <Typography className={classes.title} >
              {t('navigationBar.systemTitle')}
            </Typography>

            {environmentLabel !== 'prod' && (
              <span style={{color: '#fff', fontWeight: 'bold', fontSize: '32px', padding: '16px', background: '#f43232'}}>
                {String(environmentLabel).toUpperCase()}
              </span>
            )}
          </div>

          <div className={classes.countryFlags}>
            <Avatar src={brasilFlag} className={classes.countryFlag} onClick={() => i18n.changeLanguage('pt')} />
            <Avatar src={euaFlag} className={classes.countryFlag} onClick={() => i18n.changeLanguage('en')} />
            <Avatar src={spanishFlag} className={classes.countryFlag} onClick={() => i18n.changeLanguage('es')} />
          </div>
          <div className={classes.user}>
            <Avatar src={accountIcon} />
            <Button variant="text">
              <Typography variant="subtitle1">
                {account.name}
              </Typography>
            </Button>
          </div>
          <IconButton aria-label="delete" color="primary" onClick={() => logout()}>
            <ExitToAppIcon color="secondary" />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Hidden mdUp implementation="css">
        <Drawer
          variant="temporary"
          anchor={theme.direction === 'rtl' ? 'right' : 'left'}
          open={mobileOpen}
          onClose={handleDrawerToggle}
          classes={{ paper: classes.drawerPaper }}
          ModalProps={{ keepMounted: true }}
        >
          {drawer}
        </Drawer>
      </Hidden>
      <Hidden mdDown implementation="css">
        <Drawer
          className={classes.drawer}
          variant="permanent"
          classes={{ paper: classes.drawerPaper, paperAnchorDockedLeft: classes.border }}
        >
          <Toolbar />
          {drawer}
        </Drawer>
      </Hidden>
      <main className={classes.content}>
        <Toolbar />
        {props.children}
      </main>
    </div>
  );
};

export default withTranslation()(withRouter(NavigationBar))
